import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function BeforeAfter() {
  return <section className="px-5 py-14 md:px-8 md:py-20" data-id="element-15">
      <div className="mx-auto max-w-4xl text-center" data-id="element-16">
        <FadeIn data-id="element-17">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-18">
            Una herramienta de trabajo
          </p>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-19">
            Tratado Integral de Modernización Laboral
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-stone-300" data-id="element-20">
            Todo el material que necesitás para aplicar correctamente la Ley
            27.802 sin perder tiempo redactando cada documento desde cero.
          </p>

          <div className="mx-auto mt-8 flex max-w-xl flex-col items-center justify-center gap-3 border border-accent/30 bg-accent/10 p-5 text-base font-bold text-accent sm:flex-row md:text-lg" data-id="element-21">
            <span data-id="element-22">Abrís</span>
            <ArrowRightIcon size={19} aria-hidden="true" data-id="element-23" />
            <span data-id="element-24">Adaptás</span>
            <ArrowRightIcon size={19} aria-hidden="true" data-id="element-25" />
            <span data-id="element-26">Presentás</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}